import { StrictMode } from "react";
import Router from "./Navigation";
import { LanguageProvider } from "./I18n/Languages/LanguageContext";
import { NavigationProvider } from "./components/NavigationContext/NavigationContext";

function App() {
  return (
    <StrictMode>
      <LanguageProvider>
        <NavigationProvider>
          <Router />
        </NavigationProvider>
      </LanguageProvider>
    </StrictMode>
  );
}

export default App;
